import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { Int_Menu_Items } from "../../../models/components";

@Component({
    selector: "mobi-office-lib-mat-option-chips",
    templateUrl: "./mat-option-chips.component.html",
    styleUrl: "./mat-option-chips.component.scss",
    imports: [CommonModule, MatIconModule]
})
export class MatOptionChipsComponent {
  @Input({ required: true }) model: any;
  @Input({ required: true }) optionList: Int_Menu_Items[] = [];
  @Input() isDeletable: boolean = false;
  @Input() customClass: string = "default-options";
  @Input() isSimpleText: boolean = false;

  @Output() deleteEmitter = new EventEmitter();
  @Output() modelChange = new EventEmitter();

  onDelete(item: Int_Menu_Items, $event: Event) {
    $event.stopPropagation();
    if (Array.isArray(this.model)) {
      this.model.splice(this.model.indexOf(item.ID), 1);
      this.modelChange.emit(this.model);
    } else {
      this.model = 0;
      this.modelChange.emit(this.model);
    }
    this.deleteEmitter.emit(item);
  }

  get getSelectedItems() {
    if (Array.isArray(this.model)) {
      return this.optionList.filter(item => this.model.includes(item.ID));
    } else {
      return this.optionList.filter(item => item.ID === this.model);
    }
  }
}
